import React, { useState, useEffect, Fragment } from 'react';
import {
    Row, Button,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Card
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { gAPI_Business, gAPI_Search_Business } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ProductListItem from "./components/ProductListItem";
import AddNewProduct from "./components/AddNewProduct";
import IntlMessages from "../../../../../helpers/IntlMessages";
import Pagination from "../../../../../containers/pages/Pagination";
import product_services_guide from '../../../../../assets/product_services.png'
import { locale } from 'moment';


function Index({ propertyId, locale }) {
    const [buisnessList, setBuisnessList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(false);
    const [orderBy, setOrderBy] = useState({ column: "title", label: "Name" });
    const [search, setSearch] = useState('');
    const [userpageSizes, setuserpageSizes] = useState([10, 15, 20, 25]);
    const [usercurrentPage, setusercurrentPage] = useState(1);
    const [userSelectedPageSize, setuserSelectedPageSize] = useState(10);
    const [userTotalItems, setuserTotalItems] = useState(0);
    const [userTotalPages, setuserTotalPages] = useState(1);
    const [categoryList, setCategoryList] = useState([]);
    const orderOptions = [
        { column: "title", label: "Name" },
        { column: "displayOrder", label: "Display Order" }
    ];
    useEffect(() => {
        LoadData();
    }, [propertyId, orderBy, search, usercurrentPage, userSelectedPageSize]);

    const LoadData = () => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Business}?propertyId=${propertyId}&orderBy=${orderBy.column}&search=${search}&pageNumber=${usercurrentPage}&pageSize=${userSelectedPageSize}`,
        })
            .then(res => {

                let sortedProducts = res.data?.products || [];
                if (orderBy.column === "displayOrder") {
                    sortedProducts = sortedProducts.sort((a, b) => a.displayOrder - b.displayOrder);
                }
                const sortedData = {
                    ...res.data,
                    products: sortedProducts
                };
                setBuisnessList(sortedData);
                // setBuisnessList(res.data);
                setuserTotalItems(res.data.totalItems)
                setuserTotalPages(res.data.totalPages)
                setLoading(false);
            })
            .catch(err => console.log('err', err));
        AxiosAPI({
            methed: 'get',
            url: `${gAPI_Search_Business}/?propertyId=${propertyId}`,
        })
            .then(res => {
                var list = [];
                res.data.map(l => { list.push({ label: l.categories, value: l.categories }) });
                setCategoryList(list);
            })
            .catch(err => {
                console.log(err);
            });
    }

    const toggleModal = () => {
        setVisible(!visible)
    };

    const changeOrderBy = column => {
        setOrderBy(orderOptions.find(x => x.column === column));
    };

    const onSearchKey = e => {
        if (e.key === "Enter") {
            setSearch(e.target.value.toLowerCase())
        }
    };

    const changeUserPageSize = size => {
        setuserSelectedPageSize(size)
        setusercurrentPage(1)
    };

    const onChangeUserPage = page => {
        setusercurrentPage(page)
    };

    if (loading) {
        return (
            <div className="loading" />
        );
    }
    const startUserIndex = (usercurrentPage - 1) * userSelectedPageSize;
    const endUserIndex = usercurrentPage * userSelectedPageSize;
    return (
        <Fragment>
            <Row className=" survey-app" >
                <Colxx xxs="12">
                    <div className="mb-2">
                        {/* <h1>
                            Products & Services
                        </h1> */}
                        {/* {!loading && (
                            <Fragment>
                                <div className="text-zero top-right-button-container">
                                    <Button
                                        color="primary"
                                        size="lg"
                                        className="top-right-button mr-1"
                                        onClick={toggleModal}
                                    >
                                        + Add New
                                    </Button>
                                </div>
                            </Fragment>
                        )} */}
                    </div>
                    <div className="mb-2">
                        <div className="d-block d-md-inline-block">
                            <UncontrolledDropdown className="mr-1  float-md-left btn-group mb-1">
                                <DropdownToggle caret color="outline-dark" size="xs">
                                    <IntlMessages id="pages.orderby" />
                                    {orderBy.label}
                                </DropdownToggle>
                                <DropdownMenu>
                                    {orderOptions.map((order, index) => {
                                        return (
                                            <DropdownItem
                                                key={index}
                                                onClick={() => changeOrderBy(order.column)}
                                            >
                                                {order.label}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <div className="search-sm d-inline-block float-md-left mr-1 mb-1  align-top">
                                <input
                                    type="text"
                                    name="keyword"
                                    id="search"
                                    placeholder="Search"
                                    onKeyPress={e => onSearchKey(e)}
                                />
                            </div>
                            {!loading && (
                                <Fragment>
                                    <div className="text-zero ml-2 top-right-button-container mr-1 d-block d-md-inline-block">
                                        <Button
                                            color="primary"
                                            size="xs"
                                            className="top-right-button mr-1"
                                            onClick={toggleModal}
                                            outline
                                        >

                                            + Add New
                                        </Button>
                                        {locale && locale === 'en' && <a href="/app/pages/propinfo/publish-ai">
                                            <Button
                                                color="primary"
                                                outline
                                                className='ml-2'
                                                size="xs"
                                            >
                                                Publish AI
                                            </Button>
                                        </a>}
                                    </div>

                                </Fragment>
                            )}

                        </div>
                        <div className="float-md-right mr-4">
                            <span className="text-muted text-small mr-1">{`${startUserIndex}-${endUserIndex} of ${userTotalItems} `}</span>
                            <UncontrolledDropdown className="d-inline-block">
                                <DropdownToggle caret color="outline-dark" size="xs">
                                    {userSelectedPageSize}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    {userpageSizes.map((size, index) => {
                                        return (
                                            <DropdownItem
                                                key={index}
                                                onClick={() => changeUserPageSize(size)}
                                            >
                                                {size}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>

                    </div>
                </Colxx>
            </Row>
            <Separator className="mb-5" />
            <div>
                {!loading ? (buisnessList?.products &&
                    buisnessList.products.length > 0 ?
                    <div>
                        <Card className="d-flex flex-row " style={{ borderRadius: '10px', backgroundColor: 'var(--theme-color-2)', marginBottom: '20px' }}>
                            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                <div className="card-body align-self-center d-flex flex-column flex-lg-row text-white" style={{ marginTop: '4px' }}>

                                    <p className="mb-1 text-small font-weight-bold w-25 w-sm-100">Title</p>
                                    <p className="mb-1 text-small font-weight-bold w-12 w-sm-100">Created By</p>
                                    {/* <p className="mb-1 text-small font-weight-bold w-18 w-sm-100">Description</p> */}
                                    <p className="mb-1 text-small font-weight-bold w-12 w-sm-100">Categories</p>
                                    <p className="mb-1 text-small font-weight-bold w-10 w-sm-100">Status</p>
                                    <p className="mb-1 text-small font-weight-bold w-15 w-sm-100">Date Created </p>
                                    <p className="mb-1 text-small font-weight-bold w-15 w-sm-100">Date Modified</p>
                                    <p className="mb-1 text-small font-weight-bold w-10 w-sm-100">Actions</p>
                                </div>
                            </div>
                        </Card>
                        {
                            buisnessList.products.map((item, index) => {
                                return (
                                    <ProductListItem
                                        key={`product_item_${index}`}
                                        item={item}
                                        toggleModal={toggleModal}
                                        LoadData={LoadData}
                                        categoryList={categoryList}
                                    />
                                );
                            })
                        }
                    </div>
                    : (
                        <Fragment>
                            <Row>
                                <Colxx xxs="12" className="mb-0 text-center">
                                    <img className='w-25' style={{ marginTop: '5rem' }} alt="Products & Services" src={product_services_guide}></img>
                                </Colxx>
                                <Colxx xxs="12" className="mb-4 text-center">
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="top-right-button mt-2 mr-1"
                                        onClick={toggleModal}

                                    >
                                        + Add Your First Product or Service
                                    </Button>

                                </Colxx>
                            </Row>
                        </Fragment>
                    )
                ) : (
                    <div className="loading" />
                )}
            </div>

            <Row>
                <Pagination
                    currentPage={usercurrentPage}
                    totalPage={userTotalPages}
                    onChangePage={i => onChangeUserPage(i)}
                />
            </Row>

            <AddNewProduct
                toggleModal={toggleModal}
                formLabel="Create a New Product"
                visible={visible}
                LoadData={LoadData}
                categoryList={categoryList}
            />
        </Fragment >
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
